import { useCallback, useState } from 'react';

type useSelectKeyboardProps = {
  options: EntityBase[]
  onChange(value: EntityBase): void
  setOpen(value: boolean): void
}

export const useSelectKeyboard = ({ options, onChange, setOpen }: useSelectKeyboardProps) => {

  const [marker, setMarker] = useState<number>();
  const onKeyDown = useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
    if (options.length === 0) {
      return;
    }
    if (event.key === 'Escap') { 
      setMarker(undefined);
      setOpen(false);
      return;
    }
    if (event.key === 'ArrowUp') { 
      if (!open || marker === 0) { 
        return;
      }
      setMarker((marker === undefined ? options.length : marker) - 1);
    }
    if (event.key === 'ArrowDown') {
      if (!open) { 
        setOpen(true);
        setMarker(0);
        return;
      }
      if (marker === options.length - 1) {
        return;
      }
      setMarker(marker === undefined ? 0 : marker + 1);
    }
    if (event.key === 'Enter' && open && marker !== undefined) {
      onChange(options[marker]);
      setMarker(undefined);
      setOpen(false);
    }
  }, [options, marker, setOpen, onChange]);


  return { marker, onKeyDown };
};